import { render, staticRenderFns } from "./EntryCollapsedValue.vue?vue&type=template&id=0bb693ba&scoped=true&"
import script from "./EntryCollapsedValue.vue?vue&type=script&lang=js&"
export * from "./EntryCollapsedValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb693ba",
  null
  
)

export default component.exports